import { makeAutoObservable, runInAction } from "mobx";

export default class criteriaStore {
  criteria = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.criteria = [];
    runInAction(() => {
      this.criteria = data;
    });
  };

  deleteCriteria = (id) => {
    let newState = this.criteria.filter((criteria) => criteria.id !== id);
    this.criteria = [];
    this.criteria = newState;
  };
}